function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var R = 6371; // Radius of the earth in km

var LocationSortingManager = /*#__PURE__*/function () {
  function LocationSortingManager() {
    _classCallCheck(this, LocationSortingManager);
  }

  _createClass(LocationSortingManager, [{
    key: "sort",
    value:
    /**
     * @param {Location[]} locations
     * @param {Location} targetLocation
     * @returns {Location[]}
     */
    function sort(locations, targetLocation) {
      var measuredLocations = locations.map(function (location) {
        location.Distance = LocationSortingManager.getDistanceFromLatLngInKm(location, targetLocation);
        return location;
      });
      return measuredLocations.sort(function (locationA, locationB) {
        if (locationA.Distance < locationB.Distance) return -1;
        if (locationA.Distance > locationB.Distance) return 1;
        return 0;
      });
    }
    /**
     * @param {Location} location1
     * @param {Location} location2
     * @private
     * @returns {number}
     */

  }], [{
    key: "getDistanceFromLatLngInKm",
    value: function getDistanceFromLatLngInKm(location1, location2) {
      var lat1 = location1.lat;
      var lng1 = location1.lng;
      var lat2 = location2.lat;
      var lng2 = location2.lng;
      var dLat = LocationSortingManager.deg2rad(lat2 - lat1); // deg2rad below

      var dLon = LocationSortingManager.deg2rad(lng2 - lng1);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km

      return d;
    }
    /**
     * @param {number} deg
     * @private
     * @returns {number}
     */

  }, {
    key: "deg2rad",
    value: function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }
  }]);

  return LocationSortingManager;
}();

export default LocationSortingManager;